<template>
<div class="h-100 d-flex flex-column">
  <Navbar v-on:update="refreshData($event)" msg="ivizri.com" />
  <router-view :chartData="chartData" :chartLabels="chartLabels" :mapData="mapData" :totalData="totalData" />
  <Footer :timestamp="timestamp" />
</div>
</template>

<script>
import Navbar from "./components/Navbar.vue"
import Footer from "./components/Footer.vue"

export default {
  components: { Navbar, Footer },
  name: "App",
  data() {
    return {
      requestData: false,
      chartData: [],
      chartLabels: [],
      mapData: [],
      totalData: [],
      timestamp: 0
    }
  },
  async beforeMount() {
    this.getTimelineData(false)
    this.getMapData()
  },
  methods: {
    refreshData: function (refreshData) {
      this.requestData = refreshData
      this.getTimelineData(this.requestData)
      this.getMapData(this.requestData)
      this.requestData = false
    },
    getTimelineData: function (update) {
      fetch("https://ri-outages-api.s3.amazonaws.com/data/timeseries/total.json")
        .then((res) => res.json())
        .then((data) => {
          if (update == true) {
            var newData = data.data[data.data.length - 1]
            console.log(this.timestamp)

            if (! this.chartLabels.includes(newData.timestamp)) {
              this.timestamp = newData.timestamp
              this.chartData.push(newData.customers_affected)
              this.chartLabels.push(newData.timestamp)
            } else {
              console.log("no new data to add")
            }
          } else {
            data.data.forEach((el) => {
              this.chartData.push(el.customers_affected)
              this.chartLabels.push(el.timestamp)
            })
          }
        })
    },
    getMapData: function () {
      fetch("https://ri-outages-api.s3.amazonaws.com/data/latest/map.json")
        .then((res) => res.json())
        .then((data) => {
          var total = data.pop()
          this.timestamp = total.timestamp
          this.totalData = total
          this.mapData = data
        })
    },
  },
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background: #1b1b1b;
  height: 100vh;
}
body {
  background-color: #1b1b1b !important
}


.footer {
  height: 35px;
  line-height: 35px;
}




</style>
